import React, { useState } from 'react';
import SliderInput from 'evcharging/components/SliderInput';
import { css } from '@emotion/css';
import Spacer from 'evcharging/components/Spacer';
import { Theme } from 'evcharging/app/themes';
import { useRouter } from 'next/router';
import useI18n from 'evcharging/hooks/useI18n';
import useTheme from 'evcharging/hooks/useTheme';
import clsx from 'clsx';

const DistanceCalculator = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const [hours, setHours] = useState<number>(2);
  const distance = hours * 25;
  const { pathname } = useRouter();
  const { t } = useI18n();

  const onChange = (value: number) => {
    setHours(value);
  };

  return (
    <>
      <div className={styles.results}>
        <div>
          <label>{t('charger.calc.time')}</label>
          <span>
            {hours} {t('charger.calc.hours')}
          </span>
        </div>
        <div>
          <label>{t('charger.calc.distance')}</label>
          <span>{distance} miles</span>
        </div>
      </div>
      <Spacer value={32} mobile={0} />
      <SliderInput
        onChange={onChange}
        value={hours}
        min={1}
        max={8}
        hideValue
        handleRender={({ props }, { value }) => {
          return (
            <div {...props} className={clsx('rc-slider-handle', styles.inputs)}>
              <div className={styles.value}>{value}</div>
            </div>
          );
        }}
      />
    </>
  );
};

const createStyles = (theme: Theme) => ({
  inputs: css`
    position: absolute;
  `,
  value: css`
    position: relative;
    bottom: -20px;
  `,
  results: css`
    display: flex;

    > div:first-child {
      margin-right: 176px;
      ${theme.breakpoints.mobile.down} {
        margin-right: 100px;
      }
    }

    label {
      display: block;
      color: #6e7c87;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      margin-top: 6px;
    }

    span {
      display: block;
      color: #252c32;
      font-weight: 600;
      font-size: 36px;
      line-height: 48px;

      ${theme.breakpoints.mobile.down} {
        font-size: 28px;
      }
    }
  `,
});

export default DistanceCalculator;
